import { pl, enGB, cs, es, ru, uk } from 'date-fns/locale';

const SUPPORTED_LOCALES = ['pl', 'en', 'cs', 'ru', 'uk', 'es']
const LOCALE_STORAGE_KEY = 'locale'

export function getPreferredLocale(fallback = 'pl') {
    const urlLocale = new URLSearchParams(window.location.search).get('locale')
    if (urlLocale && SUPPORTED_LOCALES.includes(urlLocale)) return urlLocale

    const saved = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (saved && SUPPORTED_LOCALES.includes(saved)) return saved

    const browserLanguages = navigator.languages ?? [navigator.language]
    for (const lang of browserLanguages) {
        const short = lang.split('-')[0]
        if (SUPPORTED_LOCALES.includes(short)) return short
    }

    return fallback
}

export function saveLocale(lang) {
    localStorage.setItem(LOCALE_STORAGE_KEY, lang)
}

export { SUPPORTED_LOCALES, LOCALE_STORAGE_KEY }

export function getLocaleName(locale) {
    const names = {
        pl: 'Polski',
        en: 'English',
        cs: 'Čeština',
        ru: 'Русский',
        uk: 'Українська',
        es: 'Español'
    };

    return names[locale] || '';
}

export function getDateLocale(locale) {
    switch (locale) {
        case 'pl':
            return pl;
        case 'cs':
            return cs;
        case 'es':
            return es;
        case 'ru':
            return ru;
        case 'uk':
            return uk;
        default:
            return enGB;
    }
}
